import React from "react";

const TicketAssignedEmail: React.FC = () => {
    const htmlContent = `
        <div class="flex justify-center py-8 bg-gray-100 rounded-lg">
            <div class="max-w-[600px] mx-auto bg-white shadow-lg">
                <div class="bg-gradient-to-r from-blue-600 to-blue-700 px-8 py-6">
                    <h1 class="text-white text-2xl font-semibold">Service Desk</h1>
                </div>
                <div class="px-8 py-6">
                    <h2 class="text-2xl font-semibold text-gray-900 mb-4">Ticket Assigned to You</h2>
                    <p class="text-gray-700 mb-6">A new ticket has been assigned to you and requires your attention.</p>
                    <div class="border-l-4 p-4 mb-4 bg-amber-50 border-amber-200 text-amber-800">
                        <p class="font-semibold mb-1">Action Required</p>
                        <p class="text-sm">This ticket has a high priority and is due within 4 hours.</p>
                    </div>
                    <div class="bg-gray-50 p-4 rounded-md mb-6">
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Ticket ID:</span>
                            <span class="text-gray-900"><span class="font-mono text-blue-600">#SD-2024-1547</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Subject:</span>
                            <span class="text-gray-900">Unable to access customer database</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Priority:</span>
                            <span class="text-gray-900"><span class="inline-block bg-orange-100 text-orange-800 px-2 py-1 rounded text-sm font-medium">High</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Requester:</span>
                            <span class="text-gray-900">Sarah Johnson (sarah.johnson@company.com)</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Category:</span>
                            <span class="text-gray-900">Database Access</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Due By:</span>
                            <span class="text-gray-900">May 6, 2026 at 6:30 PM</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">SLA Clock:</span>
                            <span class="text-gray-900"><span class="text-orange-600 font-medium">3h 45m remaining</span></span>
                        </div>
                    </div>
                    <div class="mb-6">
                        <h3 class="font-semibold text-gray-900 mb-2">Request Description:</h3>
                        <div class="bg-gray-50 p-4 rounded border border-gray-200">
                            <p class="text-gray-700 text-sm">I'm unable to connect to the customer database since this morning. When I try to log in, I receive an "Authentication failed" error. This is blocking my ability to process customer orders.</p>
                        </div>
                    </div>
                </div>
                <div class="bg-gray-50 px-8 py-6 border-t border-gray-200">
                    <p class="text-sm text-gray-600">This is an automated message from the Service Desk. Please do not reply directly to this email.</p>
                </div>
            </div>
        </div>
    `;
    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default TicketAssignedEmail;
